import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Birdpots from "@/pages/Birdpots";
import Furniture from "@/pages/Furniture";
import Structures from "@/pages/Structures";
import Conversions from "@/pages/Conversions";
import Contact from "@/pages/Contact";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/birdpots" element={<Birdpots />} />
          <Route path="/furniture" element={<Furniture />} />
          <Route path="/structures" element={<Structures />} />
          <Route path="/conversions" element={<Conversions />} />
          <Route path="/contact" element={<Contact />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
